import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyA0xUIp97WRt3Ltcd8HLScpONUUzE0cxp4",
    authDomain: "cityjungle-d2a5e.firebaseapp.com",
    projectId: "cityjungle-d2a5e",
    storageBucket: "cityjungle-d2a5e.appspot.com",
    messagingSenderId: "56287403874",
    appId: "1:56287403874:web:669bc5d2632a3c8014163b",
    measurementId: "G-RB1T44S6B1"
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const firebaseAuth = firebase.auth();
export const firebaseApp = firebase;
